import { CPF_REGEX_MASK } from 'util/validation'

import { LoginFormModel } from './LoginForm'

export const sanitizeLoginForm = (form: LoginFormModel): LoginFormModel => {
  const sanitizedForm = {
    ...form,
    username: CPF_REGEX_MASK.test(form.username) ? form.username.replace(/[.-]/g, '') : form.username,
  }
  return sanitizedForm
}
